import { render } from "./DocumentAccess.vue?vue&type=template&id=dd9cb81a&scoped=true"
import script from "./DocumentAccess.vue?vue&type=script&lang=js"
export * from "./DocumentAccess.vue?vue&type=script&lang=js"

import "./DocumentAccess.vue?vue&type=style&index=0&id=dd9cb81a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dd9cb81a"

export default script